import View from './views/View'

const route = {
    exact: true,
    purePath: '/courses',
    path: '/:lang/courses/:id?',
    component: View
}

export default route